import { WEI, } from "@bracket/blocksmith";
import { withdraw as withdrawV1, } from "@bracket/contractor-next/bracket-vault";
import { withdraw as withdrawV2, } from "@bracket/contractor-next/bracket-vault-v2";
import type { AmountString, } from "@bracket/types";
import type { LoadedVault, ResolverResult, VaultAddress, } from "@types";
import { isUserWalletRejection, trackVaultEvent, } from "@utils";
import { wagmiConfig as config, } from "@wagmiconfig";
import { nanoid, } from "nanoid";


export declare type WithdrawProps = {
  vault: LoadedVault;
  shares: AmountString;
}



export const withdraw = async ({
	vault,
	shares,
}: WithdrawProps): Promise<ResolverResult> => {

	const withdraw = vault.version === "2" ? withdrawV2 : withdrawV1;

	try {

		const {
			nav: { nav, },
			denomination,
			chainId,
		} = vault;
		
		const amount = WEI.fromSync(Number(shares), denomination).multiply(WEI.fromSync(nav, denomination));

		const hash = await withdraw({
			vault: vault.address as VaultAddress,
			amount: amount.toBigInt(),
			salt: nanoid(8),
			config,
			chainId,
		});

		if(hash) {

			await trackVaultEvent({
				type: "withdraw_req",
				value: amount.toNumber(),
				symbol: vault.symbol||"unknown",
				valueType: "asset",
				denomination,
			});

			return {
				success: true,
				hash,
			}
		}

		throw new Error("No transaction hash received");

	}
	catch(error) {

		if(isUserWalletRejection(error)) {
			return {
				success: false,
				rejected: true,
			}
		}

		return {
			success: false,
			rejected: false,
			error: error as Error,
		}

	}

}
